// extracted by mini-css-extract-plugin
module.exports = {"countedElements":"CountedElements-module--countedElements--2fP7y","countedElementsWithBullets":"CountedElements-module--countedElementsWithBullets--_sTOa"};